import React from "react";

const Button = ({
    children,
    variant = "",
    className = "",
    onClick,
    ...props
}) => {
    console.log(variant)
    const baseClasses =
        "px-10 py-4 transition-all duration-300 inline-block clickable";

    const variantClasses = {
        primary:
            "bg-black text-white rounded-full hover:scale-105 font-bold hover:shadow-lg transition-all duration-300",
        secondary:
            "bg-secondary-600 text-white hover:bg-gradient-to-r hover:from-blue-500 hover:to-purple-500 hover:scale-105",
        outline:
            "text-gradient hover:bg-gradient-to-r hover:from-blue-500 hover:to-purple-500 hover:text-white hover:scale-105",
        black:
            "bg-black text-white rounded-full hover:bg-gray-800 hover:scale-105 font-medium hover:shadow-lg",
    };

    return (
        <button
            className={`${baseClasses} ${variantClasses[variant]} ${className}`}
            onClick={onClick}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
